import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ConfirmModal from './ConfirmModal';
import './UserMenu.css';

const UserMenu = ({ onMyChartsClick, onDeleteAccount }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const { currentUser, logout } = useAuth();
  const menuRef = useRef(null);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!currentUser) {
    return null;
  }

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button className="user-menu-button" onClick={() => setIsOpen(!isOpen)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </button>

      {isOpen && (
        <div className="user-menu-dropdown">
          <div className="dropdown-header">
            <p className="dropdown-user-email">{currentUser.email}</p>
          </div>
          <ul className="dropdown-list">
            <li className="dropdown-item" onClick={() => { onMyChartsClick(); setIsOpen(false); }}>
              マイチャート
            </li>
            <li className="dropdown-item" onClick={() => { setIsConfirmOpen(true); setIsOpen(false); }}>
              ログアウト
            </li>
            <li className="dropdown-item dropdown-item-danger" onClick={() => { onDeleteAccount(); setIsOpen(false); }}>
              アカウントを削除
            </li>
          </ul>
        </div>
      )}

      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleLogout}
        title="ログアウトの確認"
        message="本当にログアウトしますか？"
        confirmText="ログアウト"
      />
    </div>
  );
};

export default UserMenu;
